import { render } from "./VDrinkv.vue?vue&type=template&id=58a9d80d"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VDrinkv.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58a9d80d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58a9d80d', __exports__)) {
    api.reload('58a9d80d', __exports__)
  }
  
  module.hot.accept("./VDrinkv.vue?vue&type=template&id=58a9d80d", () => {
    api.rerender('58a9d80d', render)
  })

}


export default __exports__